import React from 'react';
import { t } from '@lingui/core/macro';
import { ValidationScope } from '@/components/forms/validation';
import { ExternalAgreementParticipantCreateOptions } from '@/services/external-agreements';
import ChangeRequestParticipantSelectList from '@/seller/components/change-requests/ChangeRequestParticipantSelectList';
import { TextArea } from '@ygtechnologies/bygr-frontend-component-library';
import theme from './ExternalAgreementCreateWizardStepParticipants.module.scss';

interface ExternalAgreementCreateWizardStepParticipantsProps {
    projectId: number;
    value: ParticipantStepData;
    onChange(data: ParticipantStepData): void;
}

export interface ParticipantStepData {
    participants: ExternalAgreementParticipantCreateOptions[];
    changeRequestDescription: string;
}

const ExternalAgreementCreateWizardStepParticipants: React.FC<ExternalAgreementCreateWizardStepParticipantsProps> = ({
    value,
    onChange,
    projectId,
}) => {
    const handleChange = (changes: Partial<ParticipantStepData>) => {
        onChange({ ...value, ...changes });
    };

    return (
        <ValidationScope>
            <div className={theme.container}>
                <ChangeRequestParticipantSelectList
                    onChange={(value) => handleChange({ participants: value })}
                    projectId={projectId}
                    value={value.participants}
                    forceCurrentUser
                />

                {value.participants && value.participants.length > 1 && (
                    <TextArea
                        placeholder={t`Describe the required changes here...`}
                        required
                        className="form-control"
                        autoResize
                        minRows={4}
                        value={value.changeRequestDescription}
                        onChange={(e) => handleChange({ changeRequestDescription: e.target.value })}
                    />
                )}
            </div>
        </ValidationScope>
    );
};

export default ExternalAgreementCreateWizardStepParticipants;